import { useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { RotateCcw } from 'lucide-react';
import CurrencySelector from './CurrencySelector';
import ThemeToggle from './ThemeToggle';
import { useAppActions } from '../state/AppStateProvider';
import { useToast } from '../state/ToastProvider';

export default function Layout() {
  const { resetAll } = useAppActions();
  const { addToast } = useToast();

  const handleReset = useCallback(() => {
    const confirmed = window.confirm('Сбросить все сохранённые параметры?');
    if (!confirmed) {
      return;
    }
    resetAll();
    addToast('Параметры сброшены', 'info');
  }, [resetAll, addToast]);

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="brand">
          <span className="brand-mark" aria-hidden="true">₸</span>
          <div>
            <span className="brand-title">Finance Tools</span>
            <span className="brand-subtitle">Не сохраняет никаких данных</span>
          </div>
        </div>
        <div className="header-controls">
          <ThemeToggle />
          <CurrencySelector />
          <button type="button" className="ghost-button" onClick={handleReset}>
            <RotateCcw size={18} aria-hidden="true" />
            <span>Сбросить всё</span>
          </button>
        </div>
      </header>
      <main className="app-main">
        <Outlet />
      </main>
      <footer className="app-footer">
        <p>
          © Finance Tools — We care about your privacy |{' '}
          <a href="https://bytesvault.com" target="_blank" rel="noreferrer">
            BytesVault
          </a>
        </p>
      </footer>
    </div>
  );
}
